import { useNavigate } from "react-router-dom";
import { SelectItemsProps } from "./components/SearchSelectComponent";
import { FieldConfig } from "./components/Validations";
import Routes from "./helpers/Routes";
import Toast from "./helpers/Toast";
import { EquipmentService } from "./services/EquipmentService";

class EquipmentUtilitiesClass {

    protected equipmentService = new EquipmentService();

    public GetEquipment = async (equipmentErpId: string | null | undefined) => {

        if (!equipmentErpId) {
            console.log("Dados insuficientes : EquipmentUtilitiesClass")
            Toast.Show("error", "Dados insuficientes");
            return;
        }

        const response = await this.equipmentService.GetByIdErp(equipmentErpId);

        if (response.success === false || response.obj == null) {
            return;
        }

        return response.obj;
    };

    public SearchModel = async (model: string): Promise<SelectItemsProps[]> => {
        const response = await this.equipmentService.GetDistinctModels(model);

        if (!response.obj) {
            Toast.Show("error", response.message);
            return [];
        }

        return response.obj.map((model) => ({
            value: model,
            label: model,
        }));
    };

    public SearchBrand = async (brand: string): Promise<SelectItemsProps[]> => {
        const response = await this.equipmentService.GetDistinctBrands(brand);

        if (!response.obj) {
            Toast.Show("error", response.message);
            return [];
        }

        return response.obj.map((brand) => ({
            value: brand,
            label: brand,
        }));
    };
}

export const EquipmentUtilities = new EquipmentUtilitiesClass();

export function CreateEquipmentValidationFields(validateCarPlate: boolean): FieldConfig[] {
    const fields: FieldConfig[] = [
        ["clientErpId", "string", "Screens.Equipments.Create.ClientRequired"],
        ["serialNumber", "string", "Screens.Equipments.Create.SerialNumberRequired"],
        ["brand", "string", "Screens.Equipments.Create.BrandRequired"],
        ["model", "string", "Screens.Equipments.Create.ModelRequired"],
    ];

    if (validateCarPlate) {
        fields.splice(1, 0, ["carPlate", "string", "Screens.Equipments.Create.CarPlateRequired"]);
    }

    return fields;
}

export function EditEquipmentValidationFields(validateCarPlate: boolean): FieldConfig[] {
    const fields: FieldConfig[] = [
        ["clientErpId", "string", "Screens.Equipments.Create.ClientRequired"],
        ["serialNumber", "string", "Screens.Equipments.Create.SerialNumberRequired"],
        ["brand", "string", "Screens.Equipments.Create.BrandRequired"],
        ["model", "string", "Screens.Equipments.Create.ModelRequired"],
    ];

    if (validateCarPlate) {
        fields.splice(1, 0, ["carPlate", "string", "Screens.Equipments.Create.CarPlateRequired"]);
    }

    return fields;
}

export const useNavigateToEquipmentCreate = () => {
    const navigate = useNavigate();

    return (clientErpId: string | null | undefined, clientName: string | null | undefined) => {
        navigate(Routes.equipments.create, { state: { clientErpId, clientName } }); // state tem de ser usado, pq é uma prop da interface NavigateOptions
    };
};

//#region Tabs dinamicas
export function GetEquipmentDynamicTabIndices(availableModules: string[], baseIndex: number): { module: string, index: number }[] {
    const indices = [];
    let currentIndex = baseIndex;

    // Tabs por defeito
    indices.push({ module: "IsActiveAssistancesModule", index: currentIndex++ });

    // Tabs dinâmicas com base nos módulos disponíveis
    if (availableModules.includes("ProjectSage50cIsActiveProjectModule")) {
        indices.push({ module: "ProjectSage50cIsActiveProjectModule", index: currentIndex++ });
    }

    if (availableModules.includes("IsActiveScheduler")) {
        indices.push({ module: "IsActiveScheduler", index: currentIndex++ });
    }

    if (availableModules.includes("IsActiveMaintenanceModule")) {
        indices.push({ module: "IsActiveMaintenanceModule", index: currentIndex++ });
    }

    if (availableModules.includes("IsActiveCountersModule")) {
        indices.push({ module: "IsActiveCountersModule", index: currentIndex++ });
    }

    if (availableModules.includes("IsActiveEquipmentCountersModule")) {
        indices.push({ module: "IsActiveEquipmentCountersModule", index: currentIndex++ });
    }

    return indices;
}